export default "/50f517735fec46580f19aae3e56e9fe21614ea75/a2cdf02300b2663230f496dbfe02b4a0.svg";